import React from 'react';
import { Link } from 'react-router-dom';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';

export const ADMIN_WAREHOUSE_LIST_COLUMNS = [
  {
    accessorKey: 'id',
    header: 'Address Name',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, name } = original;

      return (
        <Link to={paths.warehouseDetails(id)}>
          <strong>{name}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'party_name',
    header: 'Party Name',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { party_name } = original;

      return <span>{party_name}</span>;
    },
  },
  {
    accessorKey: 'address',
    header: 'Address',
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const {
        address_line_1,
        address_line_2,
        address_city,
        address_state,
        address_country,
        address_pincode,
      } = original;

      return (
        <>
          <div>{address_line_1}</div>
          {address_line_2 && <div>{address_line_2}</div>}
          <div>
            {address_city} {address_state}
          </div>
          <div>
            {address_country} {address_pincode}
          </div>
        </>
      );
    },
  },
  {
    accessorKey: 'inventory_available',
    header: 'Status',
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { inventory_available } = original;

      return (
        <SubtleBadge pill bg={inventory_available ? 'success' : 'secondary'}>
          {inventory_available ? 'Available' : 'Unavailable'}
        </SubtleBadge>
      );
    },
  },
];
